import { useEffect, useState } from "react";
import { X } from "lucide-react";
import api from "@/lib/api";

export default function IBClients() {
  const [clients, setClients] = useState(null);
  const [query, setQuery] = useState("");

  useEffect(() => {
    api.get("/ib/clients").then((res) => setClients(res.data)).catch(() => setClients([]));
  }, []);

  const q = query.trim().toLowerCase();
  const filtered = clients === null ? null : !q ? clients : clients.filter((c) =>
    [c.uid, c.username, c.full_name, c.email].some((v) => (v || "").toLowerCase().includes(q))
  );

  return (
    <div className="space-y-6" data-testid="ib-clients-page">
      <div>
        <p className="eyebrow-label mb-2">Network</p>
        <h1 className="font-heading text-2xl sm:text-3xl font-bold text-white">My Clients</h1>
      </div>

      <div className="card-lux overflow-hidden">
        <div className="px-6 pt-5">
          <div className="relative sm:max-w-sm">
            <input
              type="text"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Search by UID, username, name or email…"
              className="input-lux w-full text-sm pr-9"
              data-testid="ib-clients-search-input"
            />
            {query && (
              <button onClick={() => setQuery("")} className="absolute right-3 top-1/2 -translate-y-1/2 text-[#64748B] hover:text-white transition-colors" data-testid="ib-clients-search-clear" aria-label="Clear search">
                <X className="h-4 w-4" />
              </button>
            )}
          </div>
        </div>
        <div className="overflow-x-auto mt-2">
          <table className="w-full text-sm" data-testid="ib-clients-table">
            <thead>
              <tr className="border-b border-[#222530] text-left">
                <th className="px-6 py-4 text-xs font-medium text-[#64748B] tracking-wide">UID</th>
                <th className="px-6 py-4 text-xs font-medium text-[#64748B] tracking-wide">Username</th>
                <th className="px-6 py-4 text-xs font-medium text-[#64748B] tracking-wide">Full Name</th>
                <th className="px-6 py-4 text-xs font-medium text-[#64748B] tracking-wide">Email</th>
                <th className="px-6 py-4 text-xs font-medium text-[#64748B] tracking-wide">Rank</th>
                <th className="px-6 py-4 text-xs font-medium text-[#64748B] tracking-wide">Status</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-[#222530]">
              {filtered === null ? (
                <tr><td colSpan={6} className="px-6 py-10 text-center text-[#64748B]">Loading clients...</td></tr>
              ) : filtered.length === 0 ? (
                <tr>
                  <td colSpan={6} className="px-6 py-10 text-center text-[#64748B]" data-testid="ib-clients-empty">
                    {q ? "No clients match your search." : "No clients yet. Share your referral link to grow your network."}
                  </td>
                </tr>
              ) : (
                filtered.map((c) => (
                  <tr key={c.id} className="hover:bg-[#0B0C10]/60 transition-colors" data-testid={`ib-client-row-${c.username}`}>
                    <td className="px-6 py-4 font-mono text-[#D4AF37]" data-testid={`ib-client-uid-${c.username}`}>{c.uid || "—"}</td>
                    <td className="px-6 py-4 font-mono text-white">{c.username}</td>
                    <td className="px-6 py-4 text-white">{c.full_name}</td>
                    <td className="px-6 py-4 text-[#94A3B8] break-all" data-testid={`ib-client-email-${c.username}`}>{c.email || "—"}</td>
                    <td className="px-6 py-4 text-xs font-medium text-[#D4AF37]" data-testid={`ib-client-rank-${c.username}`}>{c.rank?.name || "—"}</td>
                    <td className="px-6 py-4">
                      <span className={`text-[10px] font-mono tracking-widest uppercase rounded-full px-2.5 py-1 border ${
                        c.status === "active"
                          ? "text-emerald-400 bg-emerald-400/10 border-emerald-400/30"
                          : "text-red-400 bg-red-400/10 border-red-400/30"
                      }`}>
                        {c.status}
                      </span>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
